import React from 'react';
import styled from 'styled-components';

import { ErrorMessage } from './ErrorMessage';
import { Loading } from './Loading';
import { PageHeader } from './PageHeader';

export const StyledPage = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  margin: 16px;
  box-sizing: border-box;
  border-radius: 16px;
  width: 100%;
  min-height: 100%;
  flex: 1;
  background-color: #ffffff;
  color: var(--gray-03);

  a {
    text-decoration: underline;
    font-weight: normal;
    color: var(--gray-90);
  }

  a:hover {
    font-weight: bold;
  }

  @media (max-width: 480px) {
    padding: 16px;
    margin: 0;
    border-radius: 0;
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

type Props = Partial<{
  children: React.ReactNode;
  title: string;
  subtitle?: string;
  isLoading?: boolean;
  hasError?: boolean;
  errorMessage?: string;
  headerActions?: () => React.ReactNode;
  tabs?: {
    label: string;
    content: React.ReactNode;
  }[];
}>;

export const Page: React.FC<Props> = (props) => {
  const render = () => {
    if (props.isLoading) {
      return (
        <LoadingContainer>
          <Loading />
        </LoadingContainer>
      );
    }

    if (props.hasError) {
      return <ErrorMessage>{props.errorMessage}</ErrorMessage>;
    }

    return props.children;
  };

  return (
    <StyledPage>
      {!props.hasError && !props.isLoading && (
        <PageHeader title={props.title} description={props.subtitle} tabs={props.tabs}>
          {props.headerActions && props.headerActions()}
        </PageHeader>
      )}
      {render()}
    </StyledPage>
  );
};
